export const getContent = (count: number) => {
  return `
    <div class="room-count-overlay">
      ${count}
    </div>
  `
}
